import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Button, TextField } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import "dayjs/locale/fr-ca";

const AddCashDialog = ({
  open,
  onClose,
  onSubmit,
  cashAmountInput,
  setCashAmountInput,
  cashNotesInput,
  setCashNotesInput,
  donationDate,
  setDonationDate,
  t,
}) => {
  return (
    <Dialog fullWidth open={open} onClose={onClose}>
      <form onSubmit={onSubmit}>
        <DialogTitle>{t("addCash_text")}</DialogTitle>
        <DialogContent>
          <div className="m-2 flex flex-1 flex-col space-y-4">
            <TextField
              placeholder={t("insert_the_amount")}
              label={t("insert_the_amount")}
              type="number"
              value={cashAmountInput}
              onChange={(e) => {
                const v = e.target.value;
                if (v === "" || /^\d*\.?\d{0,2}$/.test(v)) setCashAmountInput(v);
              }}
              required
            />
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="fr-ca">
              <DatePicker
                value={donationDate ? dayjs(donationDate) : null}
                onChange={(value) => setDonationDate(value ? value.format("YYYY-MM-DD") : "")}
                label={t("date_of_donations")}
                sx={{ width: "100%" }}
                maxDate={dayjs(new Date())}
                slotProps={{ textField: { error: false, required: true } }}
              />
            </LocalizationProvider>
            <TextField
              label={t("notes", { defaultValue: "Notes" })}
              placeholder={t("notes", { defaultValue: "Notes" })}
              value={cashNotesInput}
              onChange={(e) => setCashNotesInput(e.target.value)}
              multiline
              minRows={3}
              inputProps={{ maxLength: 500 }}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button color="primary" variant="contained" type="submit">
            {t("add_text")}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default AddCashDialog;
